import { Rsp } from '@app/types/internal';

const transformRspsList = (rsps: Rsp[], hasPlTypes: boolean) => {
    const reducedRsps = rsps.map(({ rightsholder, sponsor, placement }) => {
        const reducedPlacement = { id: placement?.id, name: placement?.name };
        if (hasPlTypes) {
            const placementType = placement?.placementType || {
                id: 0,
                name: 'No placement type',
            };
            return {
                rightsholder,
                sponsor,
                placement: reducedPlacement,
                placementType,
            };
        }
        return { rightsholder, sponsor, placement: reducedPlacement };
    });

    return reducedRsps;
};

export default transformRspsList;
